import BaseEvent from "ol/events/Event";
import Vue from "vue";
import ContextMenuEvent, { ContextMenuEventType } from "./ContextMenuEvent";

export enum ContextMenuCommandType {
    CopyLatLngToClipboard = 'copylatlngtoclipboard',
    OpenInGoogleMaps = 'openingooglemaps',
    AddWaypoint = 'addwaypoint'
}

export class ContextMenuCommandEvent extends BaseEvent {
    commandType: ContextMenuCommandType
    constructor(commandType: ContextMenuCommandType) {
        super(ContextMenuEventType.Command)
        this.commandType = commandType
    }
}

export default Vue.extend({
    name: "ContextMenu",
    data: () => ({
    }),
    props: {
    },
    methods: {
        copyLatLongToClipboard() { this.$emit(ContextMenuEventType.Command, ContextMenuCommandType.CopyLatLngToClipboard) },
        openInGoogleMaps() { this.$emit(ContextMenuEventType.Command, ContextMenuCommandType.OpenInGoogleMaps) },
        addWaypoint() { this.$emit(ContextMenuEventType.Command, ContextMenuCommandType.AddWaypoint)}
    }
})